import React from 'react'

const SectionTitle = ({children}) => {
  return (
    <h2 className="estilo section-title text-5xl mt-5 font-bold">{children}</h2>
  )
}

export default SectionTitle